/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedSalaryRequestDto } from '../../models/backend-patched-salary-request-dto';
import { BackendSalaryDto } from '../../models/backend-salary-dto';

export interface OpexesSalaryPartialUpdate$Params {
  id: number;
  body?: BackendPatchedSalaryRequestDto;
}

export function opexesSalaryPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesSalaryPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, opexesSalaryPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSalaryDto>;
    }),
  );
}

opexesSalaryPartialUpdate.PATH = '/api/opexes/salary/{id}/';
